export default __webpack_public_path__ + "static/media/_brood.46f8e18c.png";